module.exports = __webpack_public_path__ + "static/rod-lewis-c1babec08446be0722d2e097711288db.png";